<template>
  <div class="container-fluid">
    <panel Title="مدیریت محتواها " Des="در این بخش میتوانید فرم ها و محتواهای خود را برای دانلود کاربران مدیریت کنید" :IsBtnBack="true" ClassCustom="bg-dark-Custom text-right mt-2"></panel>
    <net-pa-card>
      <template slot="header">
        <h6 class="text-right"><i class="fas fa-file"></i> مدیریت فایلها</h6>
      </template>
      <template slot="content">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <h6>لیست فایلها</h6>
              <hr />
              <files-list :key="RenderFilesList" IsAdmin="true"></files-list>
            </div>
            <div class="col-12 mt-4">
              <h6>افزودن فایل جدید</h6>
              <hr />
              <div class="row">
                <div class="col-md-4 col-12 border Rounded p-3 mr-4">
                  <uploader :whithName="true" :Idu="'FormFile'" :key="keyrender" :base64="null" :TableName="'ExtraForms'" @Done="GetFile" :attachId="null" :address="null" :grp="181070513" :title="'فایل خود را بارگذاری کنید'" :MasterId="$session.get('CustCode')"></uploader>
                </div>
              </div>
              <!-- <uploader :Idu="'FormFile'" :key="keyrender" :base64="GetBase(181070513)" @Done="GetFile" :attachId="GetId(181070513)" :address="GetAddress(181070513)" :grp="181070513" :title="'فایل خود را بارگذاری کنید'" :MasterId="$session.get('CustCode')"></uploader> -->
            </div>
          </div>
        </div>
      </template>
    </net-pa-card>
  </div>
</template>
<script>
import NetPaCard from '../../Tools/NetPa/NetPaCard.vue'
import Panel from '../../Tools/NetPa/Panel.vue'
import uploader from '../Componenets/NetpaUploader.vue'
import FilesList from './FilesList.vue'

export default {
  components: { Panel, NetPaCard, uploader, FilesList },
  data() {
    return {
      keyrender: 0,
      RenderFilesList: 0,
      columns: [
        {
          label: 'id',
          name: 'filename',
          visibility: false,
        },
        {
          label: 'id',
          name: 'id',
          visibility: false,
        },
        {
          label: 'id',
          name: 'id',
          visibility: false,
        },
      ],
    }
  },
  methods: {
    GetFile() {
      this.RenderFilesList++
    },
  },
  mounted() {
    this.GetFile()
  },
}
</script>
